'use client';

import { useTranslations } from '@fshr/context/i18n-context';
import { format, parseISO } from 'date-fns';
import { IconCloseCircle, IconOffers } from '../icon';
import { cn } from '@fshr/shared-react';
import { DialogOfferDataType } from '../types';
import CheckmarkFill from '../icon/checkmark_fill';
import CloseAlt from '../icon/close-alt';

type OfferElementProps = {
	offer: DialogOfferDataType;
	isInDialog?: boolean;
	mainContainerClassName?: string;
	showPreferredPartnerIndicators?: boolean;
	isPreferredPartner?: boolean;
	isInRateDialog?: boolean;
};

export const OfferComponent = ({
	offer,
	isInDialog = false,
	mainContainerClassName = 'spacing-stack-m',
	showPreferredPartnerIndicators = false,
	isPreferredPartner,
	isInRateDialog = true,
}: OfferElementProps) => {
	const translate = useTranslations();
	const hasFreeCancell = !!offer.cancellationBy;
	const hasFreeNight = offer.freeNightsIncluded;

	if (
		!hasFreeCancell &&
		!hasFreeNight &&
		!offer.nonRefundableMessage &&
		(isPreferredPartner === undefined || !showPreferredPartnerIndicators)
	) {
		return null;
	}

	return (
		<div className={cn(mainContainerClassName)}>
			{isInDialog ? (
				<>
					{isPreferredPartner !== undefined && showPreferredPartnerIndicators ? (
						<div className="flex flex-row items-center spacing-inline-xs text-caption">
							{isPreferredPartner ? (
								<CheckmarkFill className="fill-success-icon" height={18} width={18} />
							) : (
								<IconCloseCircle className="fill-error-icon" width={18} height={18} />
							)}
							<span
								className={cn({
									'text-error-text': !isPreferredPartner,
									'text-success-text': isPreferredPartner,
								})}
							>
								{isPreferredPartner
									? translate('Preferred Partner Benefits included')
									: translate('Preferred Partner Benefits NOT included')}
							</span>
						</div>
					) : null}
					{hasFreeNight ? (
						<div className="flex flex-row items-center spacing-inline-xs">
							<IconOffers className="relative top-1" width={18} height={18} />
							<span className="text-caption">{translate('Free Night(s) Applied')}</span>
						</div>
					) : null}
					{hasFreeCancell ? (
						<div className="flex flex-row items-center spacing-inline-xs">
							<IconOffers className="relative top-1" width={18} height={18} />
							<span className="text-caption">
								{translate('Free Cancellation until')}{' '}
								{offer.cancellationBy
									? format(parseISO(offer.cancellationBy), 'MMM d, yyyy')
									: null}
							</span>
						</div>
					) : offer.nonRefundableMessage ? (
						<div className="flex flex-row items-center spacing-inline-xs">
							{!isInRateDialog ? <CloseAlt width={18} height={18} /> : null}
							<p
								className={cn('text-caption', {
									'font-bold': isInRateDialog,
								})}
							>
								<span
									className={cn({
										'text-text-secondary': !isInRateDialog,
									})}
								>
									{offer.nonRefundableMessage}
								</span>
							</p>
						</div>
					) : null}
				</>
			) : (
				<>
					{isPreferredPartner !== undefined && showPreferredPartnerIndicators ? (
						<div className="flex flex-row items-center spacing-inline-xs text-caption">
							{isPreferredPartner ? (
								<CheckmarkFill className="fill-success-icon" height={18} width={18} />
							) : (
								<IconCloseCircle className="fill-error-icon" width={18} height={18} />
							)}
							<span
								className={cn({
									'text-error-text': !isPreferredPartner,
									'text-success-text': isPreferredPartner,
								})}
							>
								{isPreferredPartner
									? translate('Preferred Partner Benefits included')
									: translate('Preferred Partner Benefits NOT included')}
							</span>
						</div>
					) : null}
					{hasFreeNight ? (
						<div className="flex flex-row items-center spacing-inline-xs">
							<span className="text-caption">
								<b>{translate('Free Night(s) Applied')}</b>
							</span>
						</div>
					) : null}
					{hasFreeCancell ? (
						<div className="flex flex-row items-center spacing-inline-xs">
							<span className="text-caption">
								<b>{translate('Free Cancellation until')} </b>
								{offer.cancellationBy
									? format(parseISO(offer.cancellationBy), 'MMM d, yyyy')
									: null}
							</span>
						</div>
					) : offer.nonRefundableMessage ? (
						<div className="flex flex-row items-center spacing-inline-xs">
							{!isInRateDialog ? <CloseAlt width={18} height={18} /> : null}
							<p
								className={cn('text-caption', {
									'font-bold': isInRateDialog,
								})}
							>
								<span
									className={cn({
										'text-text-secondary': !isInRateDialog,
									})}
								>
									{offer.nonRefundableMessage}
								</span>
							</p>
						</div>
					) : null}
				</>
			)}
		</div>
	);
};
